export const DELIVERY_TYPE_TRANSLATION = {
  'Despacho a domicilio': 'Envío a domicilio',
  'Retiro en tienda': 'Retiro en Oficina',
  'Retiro en Tienda': 'Retiro en Tienda',
  'Retiro en punto': 'Pinflag Click and Collect'
}

export const BILLING_KEY_TRANSLATION = {
  corporateName: 'Razón social',
  category: 'Giro',
  corporateRut: 'Rut',
  corporatePhone: 'Teléfono',
  address: 'Dirección',
  district: 'Comuna',
  regionCode: 'Región'
}

export const BUTTON_TEXT_TRANSLATION_DELIVERY = {
  standard: 'Continuar',
  express: 'Continuar',
  'same-day': 'Continuar',
  clickAndCollect: 'Elegir Punto',
  localPickup: ['Continuar', 'Elegir Tienda']
}

export const BILLING_FIELD_TO_CUSTOM_KEY = {
  corporateName: 'customBusinessName',
  category: 'customBusinessLine',
  corporateRut: 'customSsn',
  corporatePhone: 'customBusinessPhone',
  address: 'customBusinessAddress',
  district: 'customBusinessMunicipality',
  regionCode: 'customBusinessState'
}

export const BILLING_FIELD_TO_ACTIVE_KEY = {
  corporateName: 'businessName',
  category: 'businessLine',
  corporateRut: 'ssn',
  corporatePhone: 'businessPhone',
  address: 'businessAddress',
  district: 'businessMunicipality',
  regionCode: 'businessState'
}
